// extracted by mini-css-extract-plugin
module.exports = {"search-container":"algoliaSearchBox_search-container__KXKpj"};